import { render, staticRenderFns } from "./CasinoFiltres.vue?vue&type=template&id=0bc97148"
import script from "./CasinoFiltres.vue?vue&type=script&lang=js"
export * from "./CasinoFiltres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports